const hotDishes = [

    { name: "Рулет курячий фарширований сиром в карамельному соусі", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 260, 
        price: 300, 
        image: "",
        ingredients: '' 
    },

    { name: "Жульєн грибний", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 200, 
        price: 150, 
        image: "",
        ingredients: '(печериці, вершки, сир твердий, цибуля)' 
    },

    { name: "Жульєн м'ясний", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 300, 
        price: 250, 
        image: "",
        ingredients: '(філе курки, печериці, вершки, сир твердий, цибуля)' 
    },

    { name: "Голубці домашні з сметаною", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 'За 100', 
        price: 48, 
        image: "",
        ingredients: '' 
    },

    { name: "Капуста тушкована з грибами", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 'За 100', 
        price: 20, 
        image: "",
        ingredients: '' 
    },

    { name: "Капуста тушкована з м'ясом", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 'За 100', 
        price: 22, 
        image: "",
        ingredients: '' 
    },

    { name: "Зрази з грибами", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 300, 
        price: 200, 
        image: "",
        ingredients: '' 
    },

    { name: "Зрази з мясом", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 300, 
        price: 200, 
        image: "",
        ingredients: '' 
    },

    { name: "Млинці Бонапарт", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 220, 
        price: 200, 
        image: "",
        ingredients: '(шинка, соус бешамель)' 
    },

    { name: "Млинці з м'ясом", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 190, 
        price: 200, 
        image: "",
        ingredients: '' 
    },

    { name: "Млинці з печерицями", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 190, 
        price: 200, 
        image: "",
        ingredients: '' 
    },

    { name: "Млинці з плавленим сиром, яйцем та зеленню", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 200, 
        price: 250, 
        image: "",
        ingredients: '' 
    },

    { name: "Млинці з куркою та печерицями", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 220, 
        price: 220, 
        image: "",
        ingredients: '' 
    },

    {   name: "Млинці з сомом", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: '170/45', 
        price: 260, 
        image: "/images/mlyntsi_z_somom.jpg",
        ingredients: '' 
    },

    { name: "Картопляні ньокі з соусом з білих грибів", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 200, 
        price: 200, 
        image: "",
        ingredients: '' 
    },

    { name: "Курячий рулет з вʼяленими томатами , шпинатом та сиром дорблю", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 300, 
        price: 350, 
        image: "/images/Kuryachyi_rulet_z_vyalenymy_tomatamy_shpynatom_ta_syrom_dorblyu.jpg",
        ingredients: '' 
    },

    { name: "Печериці фаршировані", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 170, 
        price: 250, 
        image: "",
        ingredients: '' 
    },

    { name: "Рулети з баклажанів з горіхами по-грузинськи", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 200, 
        price: 200, 
        image: "",
        ingredients: '' 
    },

    { name: "Печінка теляча смажена з цибулею", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: '130/30', 
        price: 160, 
        image: "",
        ingredients: '' 
    },

    { name: "Печінка теляча з печерицями у вершковому соусі", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 180, 
        price: 200, 
        image: "",
        ingredients: '' 
    },

    { name: "Равіолі з шпинатом і сиром під вершками з пармезаном", 
        category: 'Гарячі страви', 
        unit: ' г', 
        amount: 250, 
        price: 220, 
        image: "",
        ingredients: '' 
    },

 
];

export default hotDishes;